.root {
    width: 100%;
    height: 100%;
}

.scrollableContent {
    flex: 1;
    overflow-y: auto;
    overflow-x: hidden;
}
